export default __webpack_public_path__ + "static/media/M1A_3.4a117c0a.png";